import script from "./PromptsMarketing2025.vue?vue&type=script&setup=true&lang=js"
export * from "./PromptsMarketing2025.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__